export const FEE_FALLBACK = Object.freeze({
  FREE: "SportMingle takes a platform fee on each player payment.",
  PAID: "Paid clubs do not pay an extra SportMingle transaction fee.",
});

export const CUSTOMER_PAY_FEE_COPY = Object.freeze({
  label: "Does the club’s customer pay the processing fee?",
  help: "Player card checkout only (cart and events), on Free and Paid. It does not apply when you upgrade the SportMingle plan. Offline payments have no Stripe fee.",
});

export function platformFeeLabel(fee, fallback) {
  const label = typeof fee === "string" ? fee : fee?.displayLabel;
  return (label && String(label).trim()) || fallback;
}

export function currentPlanName(subscription, selectedClub) {
  if (subscription?.subscriptionName) {
    return subscription.subscriptionName;
  }
  if (selectedClub?.freePlanUser === true) {
    return "Free";
  }
  return "";
}

export function isSelectedPlatformPlan(plan, planName) {
  if (!planName || !plan?.productName) {
    return false;
  }
  return String(plan.productName).toLowerCase() === String(planName).toLowerCase();
}

export function isFreePlanSetup(stepperDetails, selectedClub) {
  return stepperDetails?.freePlan === true || selectedClub?.freePlanUser === true;
}

export const PLAN_COMPARE = Object.freeze({
  kicker: "Your club plan",
  title: "Free vs paid, at a glance",
  lead: "Start on Free today. Paid is a subscription with a lower take when players pay you.",
  free: {
    name: "Free",
    price: "$0 / month",
    points: [
      "Calendar, members, and club tools with no monthly bill",
      "SportMingle takes a platform fee on each player payment",
      "Upgrade anytime from Plan",
    ],
  },
  paid: {
    name: "Paid",
    price: "Subscription",
    points: [
      "30-day trial, then the price on the card",
      "Paid clubs do not pay an extra SportMingle transaction fee",
      "Same club tools, billed monthly or yearly",
    ],
  },
});

export function vendorGuideCopy({ isFreePlan, freeFeeLabel, paidFeeLabel }) {
  const feeLine = isFreePlan
    ? platformFeeLabel(freeFeeLabel, FEE_FALLBACK.FREE)
    : platformFeeLabel(paidFeeLabel, FEE_FALLBACK.PAID);

  return {
    kicker: "Payouts",
    title: "Connect a vendor when you are ready to take payments",
    items: [
      {
        label: "Why this step",
        body: "Stripe lets players pay the club and sends those funds to your bank. SportMingle does not hold the money.",
      },
      {
        label: "What you are charged",
        body: `${feeLine} Stripe also charges its card fee. Connecting an account does not bill your club today.`,
      },
      {
        label: "You can skip",
        body: "Skip for now and finish setup. Add Stripe later from My Finances. Card payments stay off until you connect.",
      },
    ],
    skipLabel: "Skip for now",
  };
}
